export default __webpack_public_path__ + "static/media/zombies.aef73799.png";